import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/support.svg";
var SupportSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  SupportSolid_default as default
};
